"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _color = _interopRequireDefault(require("color"));

var _useColors = _interopRequireDefault(require("../../hooks/useColors"));

var _MenuItem = _interopRequireDefault(require("./MenuItem"));

require("./styles.less");

var styles = {
  "menu": "meepshop-meep-ui__submenu-largeMenu-styles__menu",
  "visible": "meepshop-meep-ui__submenu-largeMenu-styles__visible",
  "menuContent": "meepshop-meep-ui__submenu-largeMenu-styles__menuContent",
  "menuItem": "meepshop-meep-ui__submenu-largeMenu-styles__menuItem",
  "menuItemGroup": "meepshop-meep-ui__submenu-largeMenu-styles__menuItemGroup",
  "menuGroup": "meepshop-meep-ui__submenu-largeMenu-styles__menuGroup",
  "menuGroupContent": "meepshop-meep-ui__submenu-largeMenu-styles__menuGroupContent",
  "showThirdLevelMenuDivider": "meepshop-meep-ui__submenu-largeMenu-styles__showThirdLevelMenuDivider"
};

var MenuContent = function MenuContent(_ref) {
  var visible = _ref.visible,
      pages = _ref.pages,
      submenuSettings = _ref.submenuSettings,
      menuSettings = _ref.menuSettings;
  // 色彩配置
  var colors = (0, _useColors["default"])();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.menu, " ").concat(visible ? styles.visible : ''),
    style: {
      '--submenu-font-size': menuSettings.submenuFontSize ? "".concat(menuSettings.submenuFontSize, "px") : '16px',
      '--submenu-color': 'var(--color-3)',
      '--submenu-background-color': 'var(--color-2)',
      '--submenu-background-color-hover': (0, _color["default"])(colors[1]).darken(0.05),
      pointerEvents: visible ? 'auto' : 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.menuContent
  }, pages.map(function (page) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      key: page.id,
      page: page,
      submenuSettings: submenuSettings,
      menuSettings: menuSettings
    });
  })));
};

var _default = MenuContent;
exports["default"] = _default;